import { useAuth } from "../auth/AuthContext";
import { useLogout } from "../auth/useLogout";
import { Button } from "./ui";

export default function AccessDeniedPage() {
  const { configured, identity } = useAuth();
  const logout = useLogout();
  return (
    <main className="access-denied" role="main">
      <div className="access-denied__card">
        <div className="page-eyebrow">Access required</div>
        <h1>Access required</h1>
        <p>
          This account has no recognized Isara Financial Modeling role. Ask your
          Isara engagement team for reader, launcher, or admin access.
        </p>
        {identity?.email && (
          <p className="muted">Signed in as {identity.email}</p>
        )}
        {configured && (
          <Button tone="secondary" onClick={logout}>
            Sign out or switch account
          </Button>
        )}
      </div>
    </main>
  );
}
